import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { createStyles as u, rem as n, Flex as p, ActionIcon as a, NumberInput as R } from "@mantine/core";
import "../ProductTile/ProductTileSkeleton.js";
import { IconTrash as f } from "../Icon/icons/Trash.js";
import { IconMinus as h } from "../Icon/icons/Minus.js";
import { IconPlus as g } from "../Icon/icons/Plus.js";
const v = u((o) => ({
  container: {
    borderRadius: o.radius.sm,
    border: `1px solid ${o.colors.gray[3]}`,
    padding: n(3)
  },
  button: {
    minHeight: n(32),
    minWidth: n(36),
    borderRadius: o.radius.xs
  },
  minus: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  plus: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  remove: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    color: o.other.semanticColors.error
  },
  inputRoot: {
    flexGrow: 1
  },
  input: {
    color: o.colors.black[4],
    border: 0,
    fontSize: "1rem",
    fontWeight: 400,
    textAlign: "center",
    cursor: "default",
    height: n(32),
    minHeight: "auto"
  }
})), C = ({ attributes: o, max: c = 12, onDecreaseClick: s, onIncreaseClick: d, onRemoveClick: t, quantity: i = 1 }) => {
  const { classes: e, cx: l } = v();
  return m(p, { className: e.container, children: [i === 1 && r(a, { className: l(e.button, e.remove), variant: "filled", color: "red.1", title: "Remove", "aria-label": "Remove", onClick: t, ...o == null ? void 0 : o["actions-quantity-picker-remove"], children: r(f, { size: 16 }) }), i > 1 && r(a, { className: l(e.button, e.minus), variant: "filled", color: "teal", title: "Decrease", "aria-label": "Decrease", onClick: s, ...o == null ? void 0 : o["actions-quantity-picker-decrease"], children: r(h, { size: 16 }) }), r(R, { classNames: {
    input: e.input,
    root: e.inputRoot
  }, hideControls: !0, value: i, max: c, min: 1, radius: 0, "aria-label": "Quantity", readOnly: !0 }), r(a, { className: l(e.button, e.plus), variant: "filled", color: "teal", disabled: i >= c, title: "Increase", "aria-label": "Increase", onClick: d, ...o == null ? void 0 : o["actions-quantity-picker-increase"], children: r(g, { size: 16 }) })] });
};
export {
  C as QuantityPicker
};
